import { config } from 'utils/config';

const INTERNAL_DOCS_URL = 'https://docs.salesplanning.varicent.com/';

export const useIsInternalDocsUrl = (): boolean => config.DOCS_SITE_URL === INTERNAL_DOCS_URL;
